import { render, staticRenderFns } from "./PartnerOrdersStatusToBeTreated.vue?vue&type=template&id=5f943124&"
import script from "./PartnerOrdersStatusToBeTreated.vue?vue&type=script&lang=js&"
export * from "./PartnerOrdersStatusToBeTreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports